import type { ExportFormat } from "~/helpers/grid/ssrmExport";

import { LinearProgress, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

import { CancelButton } from "~/components/Buttons";
import FormModal from "~/components/FormModal";
import { BodyText } from "~/components/Typographies";

interface GridExportProgressDialogProps {
	current: number;
	format: ExportFormat;
	onCancel: () => void;
	open: boolean;
	total: number;
}

const FORMAT_LABEL_KEYS: Record<ExportFormat, string> = {
	csv: "grid.export.formatCsv",
	xlsx: "grid.export.formatExcel"
};

const GridExportProgressDialog = ({ current, format, onCancel, open, total }: GridExportProgressDialogProps) => {
	const { t } = useTranslation("common");
	const percent = total > 0 ? Math.min(100, Math.round((current / total) * 100)) : 0;
	const detail =
		total > 0
			? t("grid.export.progressLoaded", { current: current.toLocaleString(), total: total.toLocaleString() })
			: t("grid.export.progressLoading");

	return (
		<FormModal
			actions={<CancelButton onClick={onCancel} />}
			onClose={onCancel}
			open={open}
			showCloseButton={false}
			title={t("grid.export.progressTitle", { format: t(FORMAT_LABEL_KEYS[format]) })}
		>
			<Stack spacing={2}>
				<BodyText>{detail}</BodyText>
				<LinearProgress value={percent} variant="determinate" />
			</Stack>
		</FormModal>
	);
};

export default GridExportProgressDialog;
